import React from 'react';
import { Table } from '../../components/tableComponent/Table';
import { TableViewProps } from '../../interface';

const TableView = ({
                     allSelected,
                     setAllSelected,
                     setSelectedRows,
                     selectedRows,
                     handleRefBet,
                     setColumnFilters,
                     columnFilters,
                     onMouseEditRight,
                     selectAll,
                     onMouseTextRight,
                     onRow,
                     order,
                     onChangePagination,
                     filters,
                     filtersFetch,
                     handleDeleteCopyAll,
                     loading,
                     height,
                     dataSource,
                     pagination,
                     columns,
                     langs
                   }: TableViewProps) => {
  return (
    <Table
      allSelected={allSelected}
      setAllSelected={setAllSelected}
      selectAll={selectAll}
      setSelectedRows={setSelectedRows}
      selectedRows={selectedRows}
      handleRefBet={handleRefBet}
      setColumnFilters={setColumnFilters}
      columnFilters={columnFilters}
      onMouseTextRight={onMouseTextRight}
      onMouseEditRight={onMouseEditRight}
      onRow={onRow}
      order={order}
      onChangePagination={onChangePagination}
      filters={filters}
      filtersFetch={filtersFetch}
      handleDeleteCopyAll={handleDeleteCopyAll}
      loading={loading}
      height={height}
      dataSource={dataSource}
      pagination={pagination}
      columns={columns}
      langs={langs}
    />
  );
};

export default TableView;